export default "__VITE_ASSET__8e226ef9__"